import managerBidDashboardSlice from './managerBidDashboard';

export {
    statusFilterSelector,
    dataviewFieldsSelector,
    employeeIdsSelector,
    debugModeSelector,
} from './managerBidDashboard';

const { actions } = managerBidDashboardSlice;

export const {
    reset,
    setStatusFilterSelected,
    setDataviewFieldsSelected,
    setEmployeeIdsSelected,
    setDebugModeEnabled,
} = actions;

export default managerBidDashboardSlice;
